import { fetchJourney, handleTicket, fetchUser } from "#shared/utils/journey";
import { useOnboardingStore } from "@/stores/onboarding";
import { useUrlParamsStore } from "@/stores/urlParams";
import { initializeJourneyApi } from "#shared/services/journeyApi";
import { FEATURES } from "@/lib/config";

export default defineNuxtPlugin(async ({ _route }) => {
  // msw is used only for development and testing
  // we use a facade to tree-shake msw and its dependencies for production builds
  const { worker } = await import("../msw-facade");
  await worker.start({ onUnhandledRequest: "bypass" });

  const lifecycleStore = useLifecycleStore();

  // Capture URL params early (before any redirects clear them)
  const urlParamsStore = useUrlParamsStore();
  urlParamsStore.captureFromUrl();

  // Initialize BRDGE Journey API (new tracking system - parallel to BRDGE Content)
  if (FEATURES.journeyApi.enabled) {
    const config = useRuntimeConfig();
    initializeJourneyApi({
      enabled: true,
      apiUrl: config.public.journeyApiUrl || "",
      apiKey: config.public.journeyApiKey || "",
      projectId: parseInt(config.public.journeyProjectId) || 1,
      appBaseUrl: config.public.journeyAppBaseUrl || "",
      errorHandling:
        (config.public.journeyErrorHandling as "silent" | "warn" | "block") ||
        "silent",
    });
  }

  const routeName = (_route.name as string) || "";

  // Do not execute the plugin logic for static pages
  if (routeName.startsWith("static-")) {
    lifecycleStore.setInitialized(true);
    return;
  }

  await handleTicket({ questName: "SWICA_HEALTH" });
  await fetchUser();
  await fetchJourney(); // prefetch journey (BRDGE Content - old system)
  await useContent(); // prefetch content

  // Clean up onboarding state after ticket handling
  await cleanUpOnboardingAfterHandleTicket();

  lifecycleStore.setInitialized(true);
});

const cleanUpOnboardingAfterHandleTicket = async () => {
  const onboardingStore = useOnboardingStore();

  const search = window.location.search;
  const searchParams = new URLSearchParams(search);
  const ticketId = searchParams.get("ticket_id");

  if (ticketId) {
    onboardingStore.$reset();
    window.setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.delete("ticket_id");
      window.history.replaceState(null, "", url.toString());
    }, 1000);
  }
};
